export const setCategoryId = '@question/setCategoryId';
export const setCategoryIds = '@question/setCategoryIds';
export const setAssigneeIds = '@question/setAssigneeIds';
export const setCurrentPage = '@question/setCurrentPage';
export const setEnquiryStatus = '@question/setEnquiryStatus';
export const setEnquiryCategories = '@question/setEnquiryCategories';
export const setInvestorStatus = '@question/setInvestorStatus';
export const setItems = '@question/setItems';
export const setTeamMembersProfile = '@question/setTeamMembersProfile';
export const setTeamMembers = '@question/setTeamMembers';
export const setItemsPerPage = '@question/setItemsPerPage';
export const setLoading = '@question/setLoading';
export const setMessage = '@question/setMessage';
export const setSelectedItems = '@question/setSelectedItems';
export const setSortDir = '@question/setSortDir';
export const setTotalItems = '@question/setTotalItems';
export const setRefreshData = '@question/setRefreshData';
export const setSingleItem = '@question/setSingleItem';
export const setOutstandingQuestions = '@question/setOutstandingQuestions';
export const setSearchText = '@question/setSearchText';
export const setCatSearchText = '@question/setCatSearchText';
export const setUserSearchText = '@question/setUserSearchText';
export const setCurrentQuestionData = '@question/setCurrentQuestionData';
export const setSelectedTemplate = '@question/setSelectedTemplate';
export const setViewTemplate = '@question/setViewTemplate';
export const setIsLoading = '@question/setIsLoading';
export const setAssignee = '@question/setAssignee';
export const setModalStatus = '@question/setModalStatus';
export const setModalType = '@question/setModalType';
export const setUpdateCategory = '@question/setUpdateCategory';
export const setIsConfirmationModalOpen = '@question/setIsConfirmationModalOpen';
export const setIsCategoryAddedRemovedRefresh = '@question/setIsCategoryAddedRemovedRefresh';
export const setIsCategoryAddedRemovedRefreshLoading = '@question/setIsCategoryAddedRemovedRefreshLoading';
export const setLockedAddToRegistryQuestionCount = '@question/setLockedAddToRegistryQuestionCount';
export const setTopThreeDotItemsOpen = '@question/setTopThreeDotsItem';

/**Kanban Outstanding board individual actions*/
export const setIsOutstandingLoading = '@question/setIsOutstandingLoading';
export const setIsOutstandingThreeDotsItemClicked = '@question/setIsOutstandingThreeDotsItem';
export const setOutstandingErrorMessage = '@question/setOutstandingErrorMessage';
export const setOutstandingSelectedItems = '@question/setOutstandingSelectedItems';
export const setOutstandingSortDir = '@question/setOutstandingSortDir';
export const setOutstandingAssignee = '@question/setOutstandingAsignee';
export const setOutstandingCategory = '@question/setOutstandingCategory';
export const setOutstandingInvestorStatus = '@question/setOutstandingInvestorStatus';
export const setOutstandingItemsPerPage = '@question/setOutstandingItemsPerPage';
export const setOutstandingCurrentPage = '@question/setOutstandingCurrentPage';
export const setOutstandingTotalItems = '@question/setOutstandingTotalItems';
export const setOutstandingTotalPages = '@question/setOutstandingTotalPages';

/**Kanban Drafted board individual actions */
export const setDraftedErrorMessage = '@question/setDraftedErrorMessage';
export const setIsDraftedLoading = '@question/setIsDraftedLoading';
export const setDraftedSelectedItems = '@question/setDraftedSelectedItems';
export const setDraftedSortDir = '@question/setDraftedSortDir';
export const setDraftedAssignee = '@question/setDraftedAsignee';
export const setDraftedCategory = '@question/setDraftedCategory';
export const setDraftedInvestorStatus = '@question/setDraftedInvestorStatus';
export const setDraftedItemsPerPage = '@question/setDraftedItemsPerPage';
export const setDraftedCurrentPage = '@question/setDraftedCurrentPage';
export const setDraftedTotalItems = '@question/setDraftedTotalItems';
export const setIsDraftedThreeDotsItemClicked = '@question/setIsDraftedThreeDotsItem';
export const setDraftedTotalPages = '@question/setDraftedTotalPages';

/**Kanban Resolved board individual actions */
export const setResolvedErrorMessage = '@question/setResolvedErrorMessage';
export const setIsResolvedLoading = '@question/setIsResolvedLoading';
export const setResolvedSelectedItems = '@question/setResolvedSelectedItems';
export const setResolvedSortDir = '@question/setResolvedSortDir';
export const setResolvedAssignee = '@question/setResolvedAsignee';
export const setResolvedCategory = '@question/setResolvedCategory';
export const setResolvedInvestorStatus = '@question/setResolvedInvestorStatus';
export const setResolvedItemsPerPage = '@question/setResolvedItemsPerPage';
export const setResolvedCurrentPage = '@question/setResolvedCurrentPage';
export const setResolvedTotalItems = '@question/setResolvedTotalItems';
export const setIsResolvedThreeDotsItemClicked = '@question/setIsResolvedThreeDotsItem';
export const setResolvedTotalPages = '@question/setResolvedTotalPages';

/**Archive board individual actions */
export const setArchivedErrorMessage = '@question/setArchivedErrorMessage';
export const setIsArchivedLoading = '@question/setIsArchivedLoading';
export const setArchivedSelectedItems = '@question/setArchivedSelectedItems';
export const setArchivedSortDir = '@question/setArchivedSortDir';
export const setArchivedAssignee = '@question/setArchivedAsignee';
export const setArchivedCategory = '@question/setArchivedCategory';
export const setArchivedInvestorStatus = '@question/setArchivedInvestorStatus';
export const setArchivedItemsPerPage = '@question/setArchivedItemsPerPage';
export const setArchivedCurrentPage = '@question/setArchivedCurrentPage';
export const setArchivedTotalItems = '@question/setArchivedTotalItems';
export const setIsArchivedThreeDotsItemClicked = '@question/setIsArchivedThreeDotsItem';
export const setArchivedTotalPages = '@question/setArchivedTotalPages';

export const setAllBoardItems = '@question/setAllBoardItems';
export const setReload = '@question/setReload';
export const setSelectedIdtoView = '@questions/setSelectedIdToView';
export const setViewQuestionDetailModalStatus = '@questions/setViewQuestionDetailsModal';
export const setIsInvestorHistoryOpen = '@question/setIsInvestorHistoryOpen';
export const setIsReOpenQuestion = '@question/setIsReOpenQuestion';
export const setShowSampleQuestionMessage = '@question/setShowSampleQUestionMessage';
export const setOutstandingWidth = `@question/setOutstandingWidth`;
export const setResolvedWidth = `@question/setResolvedWidth`;
export const setDraftedWidth = `@question/setDraftedWidth`;
export const setOutstandingClientWidth = `@question/setOutstandingClientWidth`;
export const setResolvedClientWidth = `@question/setResolvedClientWidth`;
export const setDraftedClientWidth = `@question/setDraftedClientWidth`;
export const setIsOutstandingBoardExtended = `@question/setIsOutstandingBoardExtended`;
export const setIsDraftedBoardExtended = `@question/setIsDraftedBoardExtended`;
export const setIsResolvedBoardExtended = `@question/setIsResolvedBoardExtended`;
export const setIncrementOutstandingWidth = `@question/setIncrementOutstandingWidth`;
export const setIncrementDraftedWidth = `@question/setIncrementDraftedWidth`;
export const setIncrementResolvedWidth = `@question/setIncrementResolvedWidth`;
export const setReloadOutstanding = `@question/setReloadOutstanding`;
export const setReloadtDrafted = `@question/setReloadtDrafted`;
export const setReloadResolved = `@question/setReloadResolved`;
export const setReloadOutstandingUpdates = `@question/setReloadOutstandingUpdates`;
export const setReloadtDraftedUpdates = `@question/setReloadtDraftedUpdates`;
export const setReloadResolvedUpdates = `@question/setReloadResolvedUpdates`;
export const setIsUpdatesForThreeDots = `@question/setIsUpdatesForThreeDots`;
export const setIsUpdatesForViewItem = `@question/setIsUpdatesForViewItem`;
export const setIsMultipleAssignee = `@question/setIsMultipleAssignee`;
export const setIsMultipleCategory = `@question/setIsMultipleCategory`;
export const setThreeDotsTarget = `@question/setThreeDotsTarget`;
export const setUpdatesForArchive = `@question/setUpdatesForArchive`;
export const setSelectedIdForTaskThreeDots = `@question/setSelectedIdForTaskThreeDots`;
export const setIsUpdatesForArchived = `@question/setIsUpdatesForArchived`;
export const setIsQuickResponseOpen = `@question/setIsQuickResponseOpen`;
export const setHasViewedQuickResponseInfo = `@question/setHasViewedQuickResponseInfo`;
export const setSelectedQuestionRegistryId = `@question/setSelectedQuestionRegistryId`;
export const setTotalUnlockedRegistries = `@question/setTotalUnlockedRegistries`;
export const setTotalLockedRegistries = `@question/setTotalLockedRegistries`;

export const setIsUploadMedia = '@question/setIsUploadMedia';

/** Enquiry Reply List */
export const setIsEnquiryReplyLoading = `@question/setIsEnquiryReplyLoading`;
export const setEnquiryReplyCurrentPage = `@question/setEnquiryReplyCurrentPage`;
export const setEnquiryReplyTotalItems = `@question/setEnquiryReplyTotalItems`;
export const setEnquiryReplyTotalPage = `@question/setEnquiryReplyTotalPage`;
export const setEnquiryReplyList = `@question/setEnquiryReplyList`;
export const setAttachments = `@question/setAttachments`;
export const setReloadReply = `@question/setReloadReply`;
export const setEditFromReply = `@question/setEditFromReply`;

/**Live Reload Enquiry Category Reply */
export const setEnquiryCategoryReload = `@question/setEnquiryCategoryReload`;

/**Bulk actions */
export const setSelectedCards = `@question/setSelectedCards`;
export const setIsSelectAllCardsOutstanding = `@question/setIsSelectAllCardsOutstanding`;
export const setIsSelectAllCardsActive = `@question/setIsSelectAllCardsActive`;
export const setIsSelectAllCardsResolved = `@question/setIsSelectAllCardsResolved`;
export const setAssignedMembersCards = `@question/setAssignedMembersCards`;
export const setAssignedCategoriesCards = `@question/setAssignedCategoriesCards`;
export const setSelectedExportToPdf = `@question/setSelectedExportToPdf`;
export const setIsSelectClicked = `@question/setIsSelectClicked`;
export const setIsEnquiryReplied = `@question/setIsEnquiryReplied`;
export const setQuestionContent = `@question/setQuestionContent`;
export const setIsIndeterminateStateOutstanding = `@question/setIsIndeterminateStateOutstanding`;
export const setIsIndeterminateStateResolved = `@question/setIsIndeterminateStateResolved`;
export const setIsIndeterminateStateActive = `@question/setIsIndeterminateStateActive`;

/**Submitting Reply upload */
export const setSubmittingData = `@question/setSubmittingData`;

/**Dialog close confirmation selected */
export const setDialogCloseConfirmation = `@quesiton/setDialogCloseConfirmation`;

/**Notes */
export const setNoteDetail = `@question/setNoteDetail`;
export const setSelectedNode = `@question/setSelectedNode`;
export const setIsTyped = `@question/setIsTyped`;
export const setInputNote = `@question/setInputNote`;

/**Category */
export const isCreateOrEditCategory = `@question/isCreateOrEditCategory`;
export const setSelectedCategoryEdit = `@question/selectedCategoryEdit`;
export const setReloadCategories = `@question/setReloadCategories`;
